"use strict";
"use client";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { Tooltip } from '@ark-ui/react/tooltip';
export { TooltipContext as Context } from '@ark-ui/react/tooltip';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { createSlotRecipeContext } from './utils/create-slot-recipe-context.mjs';

const tooltipRecipe = tv({
  slots: withSlotScopeClasses("tooltip", {
    arrow: "",
    arrowTip: "",
    content: [
      "bg-gray-a12 rounded shadow-sm text-bg-default font-semibold",
      "px-3 py-2 text-xs leading-[1.125rem] max-w-[16rem] z-tooltip",
      "data-[state=open]:animate-[fadeIn_0.25s_ease-out]",
      "data-[state=closed]:animate-[fadeOut_0.2s_ease-out]"
    ],
    positioner: "",
    trigger: "appearance-none cursor-pointer align-middle"
  })
});
const { withRootProvider, withContext } = createSlotRecipeContext(tooltipRecipe);
withRootProvider(
  Tooltip.RootProvider
);
const Root = withRootProvider(Tooltip.Root);
const Arrow = withContext(Tooltip.Arrow, "arrow");
const ArrowTip = withContext(
  Tooltip.ArrowTip,
  "arrowTip"
);
const Content = withContext(
  Tooltip.Content,
  "content"
);
const Positioner = withContext(
  Tooltip.Positioner,
  "positioner"
);
const Trigger = withContext(
  Tooltip.Trigger,
  "trigger"
);

export { Arrow, ArrowTip, Content, Positioner, Root, Trigger };
